/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import store from "@/store";
import { pathConstants } from "@/shared/pathConstants";
import { helpers } from "@/shared/helper";
import Vue from "vue";

var cancel;
var CancelToken = axios.CancelToken;

const cancelRequest = function() {
  if (cancel != undefined) {
    cancel("cancel");
  }
};

const cancelTokenConfig = function() {
  return new CancelToken(function executor(c) {
    cancel = c;
  });
};

const showNotificationModal = function(data) {
  data.instance.$emit("bv::show::modal", data.id);
};

const closeNotificationModal = function(data) {
  data.instance.$emit("bv::hide::modal", data.id);
  store.commit("alert/clear");
};

const fetchWorks = function(
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  cancelRequest();
  return axios
    .post(
      pathConstants.API + "/works",
      { myPager: pager, customFilter, search },
      { cancelToken: cancelTokenConfig() }
    )
    .then(
      result => result.data,
      err => {
        Vue.$log.error("fetchWorks", err);
      }
    );
};

const fetchWorksAdminAgence = function(
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search,
  agenceId
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  cancelRequest();
  return axios
    .post(
      pathConstants.API + `/works/agences/${agenceId}`,
      { myPager: pager, customFilter, search },
      { cancelToken: cancelTokenConfig() }
    )
    .then(
      result => result.data,
      err => {
        Vue.$log.error("fetchWorks", err);
      }
    );
};

const fetchWorksChargeDeProjet = function(
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  cancelRequest();
  return axios
    .post(
      pathConstants.API + `/works/chargeDeProjets`,
      { myPager: pager, customFilter, search },
      { cancelToken: cancelTokenConfig() }
    )
    .then(
      result => result.data,
      err => {
        Vue.$log.error("fetchWorks", err);
      }
    );
};

const fetchWorksChargeDeProjetById = function(
  currentPage,
  perPage,
  sortBy = null,
  sortDir = null,
  customFilter,
  search,
  userId
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  return axios
    .post(pathConstants.API + `/works/chargeDeProjets/${userId}`, {
      myPager: pager,
      customFilter: customFilter,
      search: search
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchWorks", err);
      }
    );
};

const fetchWorkById = async function(id) {
  return axios.get(`${pathConstants.API}/works/${id}`).then(
    result => result.data,
    err => {
      Vue.$log.error("fetchWorkById", err);
    }
  );
};
const fetchWorkOperations = function(
  id,
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir === "desc"
  };
  cancelRequest();
  return axios
    .post(
      `${pathConstants.API}/operations/${id}`,
      { myPager: pager, customFilter, search },
      { cancelToken: cancelTokenConfig() }
    )
    .then(
      result => {
        if (result.data) {
          return result.data;
        }
        return [];
      },
      err => {
        Vue.$log.error("fetchWorkById", err);
      }
    );
};

const fetchAllWorkOperations = function(
  id,
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir === "desc"
  };
  return axios
    .post(`${pathConstants.API}/operations/by-work-id/${id}`, {
      myPager: pager,
      customFilter,
      search
    })
    .then(
      result => {
        if (result.data) {
          return result.data;
        }
        return [];
      },
      err => {
        Vue.$log.error("fetchAllWorkOperations", err);
      }
    );
};

const fetchWorkOperation = function(refClientId, idOperation) {
  return axios
    .get(
      `${pathConstants.API}/operations/${idOperation}?refClientId=${refClientId}`
    )
    .then(
      result => result.data,
      err => {
        Vue.$log.error("fetchWorkOperation", err);
      }
    );
};
const fetchWorkMessageries = function(refClientId, loaded) {
  const config = loaded ? { showLoader: false } : {};
  return axios
    .get(
      `${pathConstants.API}${pathConstants.WORK_MESSAGERIES}/${refClientId}`,
      config
    )
    .then(
      result => result.data,
      err => {
        Vue.$log.error("fetchRefClientMessageries", err);
      }
    );
};

const submitAnswer = function(questionId, messagerieAnswerDto) {
  store.commit("loader/showAddMessagerieLoader");
  store.commit("work/setShouldLoading", questionId);
  const answer = messagerieAnswerDto.answer;
  const isEdit = messagerieAnswerDto.isEdit;
  return axios
    .post(
      `${pathConstants.API}${pathConstants.WORK_MESSAGERIES}/${questionId}/submitAnswer`,
      { answer, isEdit },
      { showLoader: false }
    )
    .then(
      () => answer,
      err => {
        Vue.$log.error("submitAnswer", err);
      }
    )
    .finally(() => {
      store.commit("loader/hideAddMessagerieLoader");
      store.commit("work/setShouldNotLoading", questionId);
    });
};

const submitModifiedAnswer = function(questionId, messagerieAnswerDto) {
  store.commit("loader/showLoadingModifyMessagerieLoader");
  store.commit("work/setShouldLoading", questionId);
  const answer = messagerieAnswerDto.answer;
  const historyId = messagerieAnswerDto.historyId;
  const isEdit = messagerieAnswerDto.isEdit;
  return axios
    .post(
      `${pathConstants.API}${pathConstants.WORK_MESSAGERIES}/${questionId}/submitAnswer`,
      { answer, historyId, isEdit },
      { showLoader: false }
    )
    .then(
      () => answer,
      err => {
        Vue.$log.error("modifyAnswer", err);
      }
    )
    .finally(() => {
      store.commit("loader/hideLoadingModifyMessagerieLoader");
      store.commit("work/setShouldNotLoading", questionId);
    });
};
const deleteAnswer = function(questionId, historyId) {
  const url = `${pathConstants.API}${pathConstants.WORK_MESSAGERIES}/${questionId}/deleteAnswer`;
  const config = { showLoader: false };
  if (historyId) {
    config.params = { historyId };
  }
  return axios.delete(url, config).then(
    () => ({ questionId, historyId }),
    err => {
      Vue.$log.error("deleteAnswer", err);
    }
  );
};

const downloadWorks = function(customFilter) {
  store.commit("loader/showDownloadWorksOrSimulations");
  axios({
    url: pathConstants.API + "/works/downloadWorks",
    data: customFilter,
    method: "POST",
    responseType: "blob",
    showLoader: false
  })
    .then(response => {
      helpers.downloadFile(response);
    })
    .finally(() => store.commit("loader/hideDownloadWorksOrSimulations"));
};

const downloadOperations = function(customFilter, workId) {
  store.commit("loader/showDownloadOperations");
  axios({
    url:
      pathConstants.API + `/operations/downloadOperations/by-work-id/${workId}`,
    data: customFilter,
    method: "POST",
    responseType: "blob",
    showLoader: false
  })
    .then(response => {
      helpers.downloadFile(response);
    })
    .finally(() => store.commit("loader/hideDownloadOperations"));
};

const fetchWorkCount = function() {
  return axios.get(pathConstants.API + "/works/count").then(
    result => result.data,
    err => {
      Vue.$log.error("fetchWorkCount", err);
    }
  );
};
const fetchWorkCountAdminAgence = function(agenceId) {
  return axios.get(pathConstants.API + `/works/count/agences/${agenceId}`).then(
    result => result.data,
    err => {
      Vue.$log.error("fetchWorkCount", err);
    }
  );
};
const fetchWorkCountChargeDeProjet = function() {
  return axios.get(pathConstants.API + "/works/count/chargeDeProjets").then(
    result => result.data,
    err => {
      Vue.$log.error("fetchWorkCount", err);
    }
  );
};

const fetchWorkOperationsCount = function() {
  return axios.get(pathConstants.API + "/works/operations/count").then(
    result => result.data,
    err => {
      Vue.$log.error("fetchWorkOperationsCount", err);
    }
  );
};

const persistSubscription = function(subscription) {
  if (subscription.agence === -1) {
    subscription.agence = null;
  }
  return axios
    .post(pathConstants.API + "/works/persistSubscription", subscription)
    .then(
      result => {
        if (result.data) {
          return result.data;
        } else {
          return {};
        }
      },
      err => {
        Vue.$log.error("persistSubscription", err);
      }
    );
};

const fetchWorkLots = function(
  id,
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir === "desc"
  };

  return axios
    .post(`${pathConstants.API}/lots/${id}`, {
      myPager: pager,
      customFilter,
      search
    })
    .then(
      result => {
        if (result.data) {
          return result.data;
        }
        return [];
      },
      err => {
        Vue.$log.error("fetchWorkLots", err);
      }
    );
};
const fetchWorkOperationsByWorkId = function(
  workId,
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  console.log("Requête API pour les opérations avec workId =", workId);
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir === "desc"
  };

  cancelRequest();
  return axios
    .post(
      `${pathConstants.API}/operations/by-work-id/${workId}`,
      { myPager: pager, customFilter, search },
      { cancelToken: cancelTokenConfig() }
    )
    .then(
      result => result.data,
      err => {
        Vue.$log.error("fetchWorkOperationsByWorkId", err);
      }
    );
};

export const workService = {
  showNotificationModal,
  persistSubscription,
  closeNotificationModal,
  fetchWorks,
  fetchWorksAdminAgence,
  fetchWorksChargeDeProjet,
  fetchWorksChargeDeProjetById,
  fetchWorkById,
  fetchWorkOperations,
  fetchAllWorkOperations,
  fetchWorkOperation,
  fetchWorkMessageries,
  submitAnswer,
  submitModifiedAnswer,
  deleteAnswer,
  downloadWorks,
  downloadOperations,
  fetchWorkCount,
  fetchWorkCountAdminAgence,
  fetchWorkCountChargeDeProjet,
  fetchWorkLots,
  fetchWorkOperationsCount,
  fetchWorkOperationsByWorkId
};
